import { render, staticRenderFns } from "./Others.vue?vue&type=template&id=008d515a&scoped=true"
import script from "./Others.vue?vue&type=script&lang=js"
export * from "./Others.vue?vue&type=script&lang=js"
import style0 from "./Others.vue?vue&type=style&index=0&id=008d515a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d515a",
  null
  
)

export default component.exports